import { useState, useEffect } from 'react';

const SIDEBAR_SELECTOR = '[class*="sidebar-nav-container"]';
const SIDEBAR_COLLAPSED_CLASS = 'collapsed';
const TRANSITION_DELAY_MS = 300;

export const useSidebarExpanded = () => {
    const [isSideNavExpanded, setIsSideNavExpanded] = useState(true);
    const [isTransitioning, setIsTransitioning] = useState(false);

    useEffect(() => {
        let timer;
        let classObserver;

        const attachToSidebar = (sidebarNavContainer) => {
            const isExpanded = () =>
                ![...sidebarNavContainer.classList].some(c => c.includes(SIDEBAR_COLLAPSED_CLASS));

            setIsSideNavExpanded(isExpanded());

            classObserver = new MutationObserver(() => {
                setIsSideNavExpanded(isExpanded());
                setIsTransitioning(true);
                clearTimeout(timer);
                timer = setTimeout(() => setIsTransitioning(false), TRANSITION_DELAY_MS);
            });

            classObserver.observe(sidebarNavContainer, { attributes: true, attributeFilter: ['class'] });
        };

        const sidebarNavContainer = document.querySelector(SIDEBAR_SELECTOR);
        if (sidebarNavContainer) {
            attachToSidebar(sidebarNavContainer);
        } else {
            // Sidebar not in DOM yet — wait for it
            const domObserver = new MutationObserver(() => {
                const sidebarNavContainer = document.querySelector(SIDEBAR_SELECTOR);
                if (sidebarNavContainer) {
                    domObserver.disconnect();
                    attachToSidebar(sidebarNavContainer);
                }
            });
            domObserver.observe(document.body, { childList: true, subtree: true });
            return () => {
                domObserver.disconnect();
                clearTimeout(timer);
                classObserver?.disconnect();
            };
        }

        return () => {
            clearTimeout(timer);
            classObserver?.disconnect();
        };
    }, []);

    return { isSideNavExpanded, isTransitioning };
};
